export enum StorageKeys {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  /** Вся сессия пользователя: токены, айди и т.д. */
  USER_SESSION = 'userSession',
  CURRENT_LOCALE = 'i18nextLng',
}
